import React from 'react';
import { motion } from 'framer-motion';
const trustPoints = ['Consulta y diseño previo sin compromiso', 'Todo se conversa, se muestra y se aprueba antes de comenzar', 'Seguimiento post-procedimiento incluido', 'Más de 6 años de experiencia respaldan cada sesión', 'Formación internacional con los referentes más importantes de la industria'];
export function TrustSection() {
  return <section className="w-full py-24 bg-[#2C1810] text-white relative overflow-hidden" data-id="element-227">
      {/* Subtle gold overlay pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-228"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-230">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-8" data-id="element-231">
            <svg className="w-8 h-8 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-232">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-233" />
            </svg>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#FDF6F0] mb-6" data-id="element-234">
            Garantía de Confianza
          </h2>
          <p className="text-[#D4AF37] font-light text-xl max-w-2xl mx-auto italic font-serif" data-id="element-235">
            "Sabemos que el mayor freno no es el dinero. Es el miedo a que quede
            mal."
          </p>
          <p className="text-white/80 font-light mt-4" data-id="element-236">
            Por eso Iara trabaja de otra manera:
          </p>
        </motion.div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 mb-12" data-id="element-237">
          <ul className="space-y-6" data-id="element-238">
            {trustPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-239">
                <div className="flex-shrink-0 mt-1" data-id="element-240">
                  <svg className="w-6 h-6 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-241">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-242" />
                  </svg>
                </div>
                <span className="text-white/90 font-light text-lg leading-relaxed" data-id="element-243">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <div className="mt-10 pt-8 border-t border-white/10 text-center" data-id="element-244">
            <p className="font-serif text-2xl text-[#D4AF37]" data-id="element-245">
              Tu rostro está en manos de alguien que realmente le importa el
              resultado.
            </p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-246">
          <a href="https://eyebrowsiaraoliver.site.agendapro.com/ar/sucursal/34777" target="_blank" rel="noopener noreferrer" className="animate-breathe px-10 py-5 rounded-full bg-gold-gradient text-white font-medium tracking-wide shadow-[0_4px_20px_rgba(212,175,55,0.3)] transition-all hover:shadow-[0_6px_25px_rgba(212,175,55,0.5)] hover:scale-105 text-lg inline-block" data-id="element-247">
            Reservar Turno
          </a>

          <div className="max-w-xl text-white/60 font-light text-sm space-y-2" data-id="element-248">
            <p data-id="element-249">
              Iara trabaja con turnos exclusivos. La agenda es limitada y se
              completa rápido.
            </p>
            <p data-id="element-250">
              Los turnos disponibles rotan semana a semana. Si estás leyendo
              esto, hay disponibilidad ahora.
            </p>
            <p className="text-[#D4AF37] font-medium" data-id="element-251">
              No esperes a que se llene.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}